import { TagServiceI } from '../../../index.d'
import { Api } from '../../api'

export class TagService implements TagServiceI {
  async addTag(id: number): Promise<unknown> {
    const { data } = await Api.post(`/api/user/tag?id=${id}`)
    return data
  }
}
